<template>
  <a-modal
    v-model="visibleAdd"
    class="modal"
    width="1000px"
    :maskClosable="false"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div slot="title" class="tip-icon">{{ title }}</div>
    <div class="message">
      <a-form-model ref="ruleForm" :model="content" :rules="rules">
      <div class="add-mess">
        <div class="contentBody">
        <div>
          <div>客户姓名：</div>
          <div>{{ content.accountName }}</div>
        </div>
        <div>
          <div>客户编号：</div>
          <div>{{ content.accountNo }}</div>
        </div>
        <div>
          <div>客户账号：</div>
          <div>{{ content.custId }}</div>
        </div>
        <div>
          <div>手机号码：</div>
          <div>{{ content.phoneNo }}</div>
        </div>
      </div>   
    </div>  
        <a-row>
          <a-col :span="24">
            <a-form-model-item
              ref="rechargeAmount"
              label="充值金额"
              prop="rechargeAmount"
            >
              <a-input
                placeholder="请输入充值金额"
                v-model="content.rechargeAmount"
                class="input-number-order"
                suffix = "元"
                type="number"
              />
              <div style="margin-top: 20px">
                <a-radio-group
                  v-model="value"
                  button-style="solid"
                  @change="onChange"
                  
                >
                  <a-radio-button value="30000.00">30000.00</a-radio-button>
                  <a-radio-button value="10000.00">10000.00</a-radio-button>
                  <a-radio-button value="5000.00">5000.00</a-radio-button>
                </a-radio-group>
              </div>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item ref="imgSts" label="充值凭证" prop="imgSts">
              <upload :downid="id" @listen="listen"></upload>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <template #footer>
      <!-- 底部按钮区域 -->
      <a-button class="btaction" @click="handleOk" :loading="disabled"
        >确 定</a-button
      >
    </template>
  </a-modal>
</template>

<script>
import { recharge, getId, queryByOpenid } from "@/api/api.js";
import upload from "@/components/upload/upload.vue";
import { DictionaryService } from "@common/services/dictionary.service";
export default {
  name: "roleAddModal",
  components: { upload },
  props: ["visible", "userData", "title", "type"],
  data() {
    var checkAge = (rule, value, callback) => {
      let reg =
        /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
      if (!value) {
          return callback(new Error("请输入充值金额"));
      }  else if (Number(value) <= 0) {
        return callback(new Error('请输入大于0的数'));
      } else if (String(parseInt(value)).length > 7) {
        return callback(new Error("请输入整数位不超过7个字符"));
      } else if (!reg.test(value)) {
        return  callback(new Error("小数点后最多只能输入两位"));
      } else {
        return  callback();
      }
    };
    return {
      value: "",
      id: "",
      //数据字典
      usrRTList: [],
      usrRSList: [],
      accountData: [],
      imgSts: "",
      //参数
      content: {
        rechargeAmount: "30000",
        imgSts: "1",
      },
      disabled: false,
      visibleAdd: this.visible,
      //校验规则
      rules: {
        rechargeAmount: [
          {
            required: true,
            validator: checkAge,
            trigger: "change",
          },
        ],
        imgSts: [
          {
            required: true,
            message: "请上传充值凭证",
          },
        ],
      },
    };
  },
  created() {
    this.getId();
    this.queryByOpenid(this.userData.openid);
  },
  methods: {
    listen(val) {
      if (val.length == 0) {
        this.imgSts = false;
      } else {
        this.imgSts = true;
      }
    },
    //获取ID
    getId() {
      let pageParam = {
        pageNum: 0,
        pageSize: 0,
        orderBy: "",
      };
      getId({ pageParam: pageParam }).then((res) => {
        this.id = res.content.id;
      });
    },
    //单选框
    onChange(e) {
      this.content.rechargeAmount = e.target.value;
    },
    //通过openid查询账户
    queryByOpenid(dataId) {
      queryByOpenid({ openId: dataId }).then(
        (res) => {
          this.accountData = res.content;
          this.$set(this.content, "accountName", this.accountData.accountName);
          this.$set(this.content, "accountNo", this.accountData.accountNo);
          this.$set(this.content, "custId", this.accountData.custId);
          this.$set(this.content, "phoneNo", this.accountData.phoneNo);
        },
        (err) => {
          this.$message.error("查询账户失败");
        }
      );
    },
    handleOk(e) {
      //弹窗确定
      if (this.imgSts) {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.disabled = true;
            recharge({
              accountNo: this.accountData.accountNo,
              custId: this.accountData.custId,
              rechargeAmount: this.content.rechargeAmount,
              rechargeFileId: this.id,
            }).then(
              (res) => {
                if (res.code == "0000") {
                  this.disabled = false;
                  this.success("充值成功");
                  this.$emit("close");
                  this.$emit("queryList");
                }
              },
              (err) => {
                this.disabled = false;
              }
            );
          }
        });
      } else {
        this.$message.error("请上传充值凭证");
      }
    },
    handleCancel() {
      //关闭弹窗
      this.$emit("close");
      this.$refs["ruleForm"].resetFields();
    },
    success(title) {
      //提示
      this.$message.success(title, 3);
    },
  },
};
</script>

<style lang="less" scoped="scoped">
.message {
  width: 100%;
  height: auto;

  .ant-form-item {
    display: flex;
    margin-bottom: 20px !important;
  }
  /deep/ .ant-form-item-label {
    width: 120px;
  }
  /deep/ .ant-form-item-control {
    width: 800px;
  }
  /deep/ .input-number-order {
    width: 350px;
  }
}

.contentBody {
    width: 92%;
    height: 100px;
    border: 1px solid #dcdcdc;
    display: flex;
    flex-wrap: wrap;
    align-content: baseline;
    margin: auto;
    border-bottom: none;
    > div {
      width: 50%;
      height: 50px;
      border-bottom: 1px solid #dcdcdc;
      display: flex;
      line-height: 50px;
      > div:first-child {
        width: 120px;
        text-align: right;
        padding-right: 5px;
        border-right: 1px solid #dcdcdc;
        background-color: #F2F2F7;
      }
      > div:last-child {
        flex: 1;
        padding-left: 10px;
      }
    }
    .one-line {
      width: 100%;
      > div:first-child {
        width: 120px;
      }
      > div:last-child {
        flex: 1;
      }
    }
    > div:nth-child(odd) {
      border-right: 1px solid #dcdcdc;
    }
  }
  .add-mess {
  width: 100%;
  //height: 400px;
  height: 120px;
  overflow: auto;
  }
</style>
